module.exports = __webpack_public_path__ + "static/media/engineers.a8d312ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/engineers.svg
// module id = 272
// module chunks = 0